module.exports = __webpack_public_path__ + "static/media/iconExclamationMark1.06707b6a.svg";